// Minimal hover helper with graceful close + intent
(function () {
  const nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  const mq = window.matchMedia('(min-width: 990px)');
  let currentOpen = null;

  function transitionMs(el) {
    if (!el) return 240;
    const cs = getComputedStyle(el);
    // transition-duration can be a list; take the longest
    const parts = (cs.transitionDuration || '').split(',').map(s => s.trim());
    const delays = (cs.transitionDelay || '').split(',').map(s => s.trim());
    const toMs = (v) => v.endsWith('ms') ? parseFloat(v) : parseFloat(v || '0') * 1000;
    let maxMs = 0;
    for (let i = 0; i < parts.length; i++) {
      maxMs = Math.max(maxMs, toMs(parts[i]) + toMs(delays[i] || '0ms'));
    }
    return maxMs || 240;
  }

  function open(details) {
    if (!mq.matches) return;
    if (currentOpen && currentOpen !== details) {
      // start closing the previous one
      close(currentOpen);
    }
    details.classList.remove('is-closing');
    details.setAttribute('open', '');
    currentOpen = details;
  }

  function reallyClose(details) {
    details.classList.remove('is-closing');
    details.removeAttribute('open');
    if (currentOpen === details) currentOpen = null;
  }

  function close(details) {
    if (!details.hasAttribute('open')) return;
    const panel = details.querySelector('.mega-menu__content');
    const ms = transitionMs(panel);
    details.classList.add('is-closing');
    const onEnd = () => { cleanup(); reallyClose(details); };
    let ended = false;
    const cleanup = () => {
      if (ended) return;
      ended = true;
      panel && panel.removeEventListener('transitionend', onEnd);
    };
    panel && panel.addEventListener('transitionend', onEnd, { once: true });
    setTimeout(onEnd, ms + 30);
  }

  function wireDesktopHover() {
    const items = nav.querySelectorAll('details.mega-menu');
    items.forEach((details) => {
      let intentTimer = null;
      const panel = details.querySelector('.mega-menu__content');
      const clear = () => { if (intentTimer) { clearTimeout(intentTimer); intentTimer = null; } };
      const scheduleClose = () => {
        clear();
        intentTimer = setTimeout(() => {
          if (details.matches(':hover')) return; // still hovered somewhere
          if (panel && panel.matches(':hover')) return;
          if (details.contains(document.activeElement)) return; // keyboard focus inside
          close(details);
        }, 160);
      };

      details.addEventListener('mouseenter', () => { if (!mq.matches) return; clear(); open(details); });
      details.addEventListener('mouseleave', () => { if (!mq.matches) return; scheduleClose(); });
      panel && panel.addEventListener('mouseenter', clear);
      panel && panel.addEventListener('mouseleave', scheduleClose);
      const summary = details.querySelector('summary');
      summary && summary.addEventListener('focus', () => open(details));
      details.addEventListener('focusout', (e) => { if (!details.contains(e.relatedTarget)) scheduleClose(); });
    });
  }

  if (mq.matches) wireDesktopHover();
  mq.addEventListener('change', (e) => {
    if (!e.matches) {
      document.querySelectorAll('details.mega-menu.is-closing').forEach(d => d.classList.remove('is-closing'));
      document.querySelectorAll('details.mega-menu[open]').forEach(d => d.removeAttribute('open'));
      currentOpen = null;
    } else {
      wireDesktopHover();
    }
  });
})();

// Custom Side Cart: lightweight upsell add + open drawer
(function () {
  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];
  // Use Shopify's Section Rendering API to update multiple UI chunks in one cart request.
  const CART_OPEN_QUERY_PARAM = 'open-cart-drawer';
  const CART_LAST_PATH_KEY = 'customCartLastStorefrontPath';

  function getCartPathname() {
    try {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      return new URL(cartUrl, window.location.origin).pathname;
    } catch (_) {
      return '/cart';
    }
  }

  function isCartPath(pathname) {
    return pathname === getCartPathname();
  }

  function persistLastStorefrontPath() {
    if (!window.sessionStorage) return;
    if (isCartPath(window.location.pathname)) return;
    if (window.location.pathname === '/checkout') return;
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get(CART_OPEN_QUERY_PARAM) === '1') return;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    try {
      window.sessionStorage.setItem(CART_LAST_PATH_KEY, current);
    } catch (_) {}
  }

  function openDrawerFromCartQueryParam() {
    const url = new URL(window.location.href);
    if (url.searchParams.get(CART_OPEN_QUERY_PARAM) !== '1') return;
    if (isCartPath(url.pathname)) return;

    const maxAttempts = 16;
    let attempts = 0;

    function cleanupUrl() {
      url.searchParams.delete(CART_OPEN_QUERY_PARAM);
      url.searchParams.delete('cart-bridge');
      const nextSearch = url.searchParams.toString();
      const nextUrl = `${url.pathname}${nextSearch ? `?${nextSearch}` : ''}${url.hash}`;
      window.history.replaceState({}, document.title, nextUrl);
    }

    function tryOpen() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return false;
      const trigger = document.querySelector('#cart-icon-bubble');
      if (typeof drawer.open === 'function') {
        drawer.open(trigger || undefined);
      } else {
        drawer.classList.add('active');
      }
      cleanupUrl();
      return true;
    }

    if (tryOpen()) return;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (tryOpen() || attempts >= maxAttempts) {
        window.clearInterval(timer);
        if (attempts >= maxAttempts) cleanupUrl();
      }
    }, 120);
  }

  persistLastStorefrontPath();
  openDrawerFromCartQueryParam();

  function publishCartUpdateIfCartPage(cartData) {
    if (!document.querySelector('cart-items') || typeof publish !== 'function') return Promise.resolve();
    if (cartData && Array.isArray(cartData.items)) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-drawer', cartData });
      return Promise.resolve();
    }
    return fetch(`${window.routes.cart_url}.js`)
      .then((r) => r.json())
      .then((data) => publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-drawer', cartData: data }))
      .catch(() => {});
  }

  function applySectionHtml(sectionId, html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');

    if (sectionId === 'cart-drawer') {
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      selectors.forEach((sel) => {
        const target = document.querySelector(sel);
        const src = doc.querySelector(sel);
        if (target && src) target.replaceWith(src);
      });
      const outer = document.querySelector('cart-drawer');
      const srcOuter = doc.querySelector('cart-drawer');
      if (outer && srcOuter) {
        outer.classList.toggle('is-empty', srcOuter.classList.contains('is-empty'));
      }
      return;
    }

    if (sectionId === 'cart-icon-bubble') {
      const srcSection = doc.getElementById('shopify-section-cart-icon-bubble');
      const markup = srcSection ? srcSection.innerHTML : doc.body.innerHTML;
      const anchors = document.querySelectorAll('#cart-icon-bubble');
      anchors.forEach((a) => { a.innerHTML = markup; });
      return;
    }

    if (sectionId === 'main-cart-items') {
      const next = doc.querySelector('cart-items');
      const current = document.querySelector('cart-items');
      if (next && current) current.replaceWith(next);
      return;
    }

    if (sectionId === 'main-cart-footer') {
      const nextFooter = doc.querySelector('#main-cart-footer');
      const currentFooter = document.getElementById('main-cart-footer');
      if (nextFooter && currentFooter) currentFooter.replaceWith(nextFooter);
    }
  }

  function applySectionsFromResponse(sections) {
    if (!sections) return false;
    Object.keys(sections).forEach((id) => applySectionHtml(id, sections[id]));
    return true;
  }

  function setCartError(message) {
    const msg = message || 'There was an error while updating your cart. Please try again.';
    const drawerError = document.getElementById('CartDrawer-CartErrors');
    if (drawerError) drawerError.textContent = msg;
    const cartError = document.getElementById('cart-errors');
    if (cartError) cartError.textContent = msg;
  }

  function clearCartError() {
    const drawerError = document.getElementById('CartDrawer-CartErrors');
    if (drawerError) drawerError.textContent = '';
    const cartError = document.getElementById('cart-errors');
    if (cartError) cartError.textContent = '';
  }

  let cartRequestQueue = Promise.resolve();

  function queueCartRequest(url, payload) {
    cartRequestQueue = cartRequestQueue
      .then(() => {
        cartMutationInFlight = true;
        clearCartError();
        const body = Object.assign({}, payload, {
          sections: CART_SECTIONS.join(','),
          sections_url: window.routes.cart_url
        });
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && (data.status === 422 || data.errors)) {
              const msg = data.description || data.message || data.errors;
              setCartError(typeof msg === 'string' ? msg : null);
              throw new Error('cart_update_failed');
            }
            return data;
          })
          .then((data) => {
            const applied = applySectionsFromResponse(data.sections);
            if (!applied) {
              replaceCartDrawerFromSection();
              replaceCartIconBubble();
            }
            refreshOffers(data && Array.isArray(data.items) ? data : null);
            publishCartUpdateIfCartPage(data && Array.isArray(data.items) ? data : null);
            return data;
          })
          .catch((err) => {
            if (err && err.message === 'cart_update_failed') return;
          })
          .finally(() => { cartMutationInFlight = false; });
      })
      .catch(() => { cartMutationInFlight = false; });
    return cartRequestQueue;
  }

  function replaceCartDrawerFromSection() {
    return fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((html) => applySectionsFromResponse({ 'cart-drawer': html }))
      .catch(() => {});
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-cart-upsell-add');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    queueCartRequest(window.routes.cart_add_url, { id, quantity: 1 })
      .then(() => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.open) drawer.open(); else drawer?.classList.add('active');
      })
      .finally(() => { btn.disabled = false; });
  });

  function setCheckoutLocked(lock) {
    const btns = new Set();
    document.querySelectorAll('#CartDrawer-Checkout, #checkout, button[name="checkout"]').forEach((b) => btns.add(b));
    btns.forEach((btn) => {
      if (!btn) return;
      btn.disabled = !!lock;
      if (btn.classList.contains('button')) {
        btn.classList.toggle('is-loading', !!lock);
      }
    });
  }

  let cartMutationInFlight = false;

  // Gift auto-remove and clamp logic
  function getGiftConfig() {
    const el = document.getElementById('CustomGiftConfig');
    if (!el) return null;
    return {
      threshold: parseInt(el.dataset.thresholdCents || '0', 10) || 0,
      productId: el.dataset.productId ? parseInt(el.dataset.productId, 10) : null,
      variantId: el.dataset.variantId ? parseInt(el.dataset.variantId, 10) : null,
      // Default to true when not provided by dataset (setting removed from editor)
      autoAdd: el.dataset.autoAdd ? String(el.dataset.autoAdd) === 'true' : true,
      available: el.dataset.available ? String(el.dataset.available) === 'true' : true,
      mode: el.dataset.mode || 'threshold',
      qualified: el.dataset.qualified ? String(el.dataset.qualified) === 'true' : false,
      qualCollectionId: el.dataset.qualCollectionId ? parseInt(el.dataset.qualCollectionId, 10) : null,
    };
  }

  function sumExcludingGift(cartData, giftVariantId, giftProductId) {
    if (!cartData || !Array.isArray(cartData.items)) return 0;
    let sum = 0;
    for (const it of cartData.items) {
      const isGift = (giftVariantId && it.variant_id === giftVariantId) || (giftProductId && it.product_id === giftProductId);
      if (isGift) continue;
      const line = typeof it.final_line_price === 'number' ? it.final_line_price : (typeof it.line_price === 'number' ? it.line_price : (it.price || 0) * (it.quantity || 1));
      sum += line;
    }
    return sum;
  }

  function findGiftItem(cartData, giftVariantId, giftProductId) {
    if (!cartData || !Array.isArray(cartData.items)) return null;
    for (let idx = 0; idx < cartData.items.length; idx++) {
      const it = cartData.items[idx];
      if ((giftVariantId && it.variant_id === giftVariantId) || (giftProductId && it.product_id === giftProductId)) {
        return { index: idx + 1, key: it.key, item: it };
      }
    }
    return null;
  }

  function changeByLine(keyOrLine, quantity) {
    return queueCartRequest(window.routes.cart_change_url, { id: keyOrLine, quantity });
  }

  // Suppression: if user removes gift manually, don’t auto-add again
  const SUPPRESS_KEY = 'customGiftSuppress';
  function isSuppressed() {
    try { return window.sessionStorage.getItem(SUPPRESS_KEY) === '1'; } catch (_) { return false; }
  }
  function setSuppressed(v) {
    try { window.sessionStorage.setItem(SUPPRESS_KEY, v ? '1' : '0'); } catch (_) {}
  }

  const OFFER_DISMISS_KEY = 'customCartOfferDismissed';
  function getDismissedOffers() {
    try {
      const raw = window.sessionStorage.getItem(OFFER_DISMISS_KEY);
      if (!raw) return new Set();
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? new Set(parsed) : new Set();
    } catch (_) {
      return new Set();
    }
  }

  function setDismissedOffer(key) {
    if (!key) return;
    const set = getDismissedOffers();
    set.add(key);
    try { window.sessionStorage.setItem(OFFER_DISMISS_KEY, JSON.stringify(Array.from(set))); } catch (_) {}
  }

  function parseCsv(value, { lower = true, upper = false } = {}) {
    if (!value) return [];
    return String(value)
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean)
      .map((v) => (upper ? v.toUpperCase() : (lower ? v.toLowerCase() : v)));
  }

  function getCartItemMetaFromDOM() {
    const meta = {
      productIds: new Set(),
      variantIds: new Set(),
      vendors: new Set(),
      tags: new Set(),
      collections: new Set()
    };
    document.querySelectorAll('.custom-cart-item[data-product-id]').forEach((el) => {
      const productId = el.dataset.productId;
      const variantId = el.dataset.variantId;
      const vendor = (el.dataset.vendor || '').trim().toLowerCase();
      if (productId) meta.productIds.add(productId);
      if (variantId) meta.variantIds.add(variantId);
      if (vendor) meta.vendors.add(vendor);
      parseCsv(el.dataset.tags || '').forEach((tag) => meta.tags.add(tag));
      parseCsv(el.dataset.collections || '', { lower: false }).forEach((id) => meta.collections.add(id));
    });
    return meta;
  }

  function hideOffer(el) {
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
  }

  function showOffer(el) {
    el.removeAttribute('hidden');
    el.removeAttribute('aria-hidden');
  }

  function evaluateOffers(cartData) {
    const container = document.querySelector('.custom-cart-offers');
    if (!container) return;
    const offers = Array.from(container.querySelectorAll('.custom-cart-offer'));
    if (!offers.length || !cartData) return;

    const showIconAdd = container.dataset.showIconAdd !== 'false';
    const showDismiss = container.dataset.showDismiss !== 'false';

    const cap = parseInt(container.dataset.offerCap || '0', 10) || 0;
    const country = (container.dataset.country || '').trim().toUpperCase();
    const meta = getCartItemMetaFromDOM();
    const cartProductIds = new Set();
    const cartVariantIds = new Set();
    if (Array.isArray(cartData.items)) {
      cartData.items.forEach((item) => {
        if (item && item.product_id) cartProductIds.add(String(item.product_id));
        if (item && item.variant_id) cartVariantIds.add(String(item.variant_id));
      });
    }
    const dismissed = getDismissedOffers();
    const eligible = [];

    offers.forEach((offer) => {
      let ok = true;
      const offerKey = offer.dataset.offerKey || '';
      if (dismissed.has(offerKey)) ok = false;

      const minSubtotal = parseInt(offer.dataset.minSubtotalCents || '0', 10) || 0;
      if (ok && minSubtotal > 0 && cartData.total_price < minSubtotal) ok = false;

      const reqProducts = parseCsv(offer.dataset.requiresProductIds || '', { lower: false });
      if (ok && reqProducts.length && !reqProducts.some((id) => meta.productIds.has(id))) ok = false;

      const reqCollections = parseCsv(offer.dataset.requiresCollectionIds || '', { lower: false });
      if (ok && reqCollections.length) {
        if (meta.collections.size === 0) {
          ok = false;
        } else if (!reqCollections.some((id) => meta.collections.has(id))) {
          ok = false;
        }
      }

      const reqTags = parseCsv(offer.dataset.requiresTags || '');
      if (ok && reqTags.length && !reqTags.some((tag) => meta.tags.has(tag))) ok = false;

      const reqVendors = parseCsv(offer.dataset.requiresVendors || '');
      if (ok && reqVendors.length && !reqVendors.some((vendor) => meta.vendors.has(vendor))) ok = false;

      const includeCountries = parseCsv(offer.dataset.countriesInclude || '', { lower: false, upper: true });
      if (ok && includeCountries.length && (!country || !includeCountries.includes(country))) ok = false;

      const excludeCountries = parseCsv(offer.dataset.countriesExclude || '', { lower: false, upper: true });
      if (ok && excludeCountries.length && country && excludeCountries.includes(country)) ok = false;

      const productId = offer.dataset.productId;
      const variantId = offer.dataset.variantId;
      const isInCart =
        (productId && (meta.productIds.has(productId) || cartProductIds.has(productId))) ||
        (variantId && (meta.variantIds.has(variantId) || cartVariantIds.has(variantId)));
      const hideIfInCart = String(offer.dataset.hideIfInCart) === 'true';
      if (ok && hideIfInCart && isInCart) {
        ok = false;
      }

      if (ok) {
        eligible.push(offer);
        const iconAdd = offer.querySelector('.custom-cart-upsell-card__iconbtn');
        if (iconAdd) {
          iconAdd.style.display = showIconAdd ? '' : 'none';
        }
        const dismiss = offer.querySelector('.custom-cart-offer__dismiss');
        if (dismiss) {
          dismiss.style.display = showDismiss ? '' : 'none';
        }
        const cta = offer.querySelector('.custom-cart-offer__cta');
        if (cta) {
          const addedText = cta.dataset.textAdded || offer.dataset.addedText || 'Added';
          const originalText = cta.dataset.textOriginal || cta.textContent;
          if (isInCart) {
            cta.textContent = addedText;
            cta.disabled = true;
            cta.classList.add('is-added');
          } else {
            cta.textContent = originalText;
            cta.disabled = false;
            cta.classList.remove('is-added');
          }
        }
      } else {
        hideOffer(offer);
      }
    });

    let shown = 0;
    eligible.forEach((offer) => {
      if (cap > 0 && shown >= cap) {
        hideOffer(offer);
        return;
      }
      showOffer(offer);
      shown += 1;
    });
  }

  let offerRefreshInFlight = null;
  function refreshOffers(cartData) {
    const container = document.querySelector('.custom-cart-offers');
    if (!container) return Promise.resolve();
    if (cartData && Array.isArray(cartData.items)) {
      evaluateOffers(cartData);
      return Promise.resolve();
    }
    if (offerRefreshInFlight) return offerRefreshInFlight;
    offerRefreshInFlight = fetch(`${window.routes.cart_url}.js`)
      .then((r) => r.json())
      .then((data) => {
        offerRefreshInFlight = null;
        evaluateOffers(data);
      })
      .catch(() => { offerRefreshInFlight = null; });
    return offerRefreshInFlight;
  }

  // Helpers to refresh UI pieces without full page reload
  function replaceCartDrawerFromSection() {
    return fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        selectors.forEach((sel) => {
          const target = document.querySelector(sel);
          const src = doc.querySelector(sel);
          if (target && src) target.replaceWith(src);
        });
        refreshOffers();
      })
      .catch(() => {});
  }

  function replaceCartDrawerAll() {
    const outer = document.querySelector('cart-drawer');
    const wasActive = outer && outer.classList.contains('active');
    return fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((html) => {
        applySectionsFromResponse({ 'cart-drawer': html });
        if (wasActive && outer) outer.classList.add('active');
        refreshOffers();
      })
      .catch(() => {});
  }

  function replaceCartIconBubble() {
    return fetch(`?section_id=cart-icon-bubble`)
      .then((r) => r.text())
      .then((html) => applySectionsFromResponse({ 'cart-icon-bubble': html }))
      .catch(() => {});
  }

  // Replace/refresh main cart when present
  function refreshCartPage() {
    const cartItemsEl = document.querySelector('cart-items');
    if (!cartItemsEl) return Promise.resolve();
    return fetch(`${window.routes.cart_url}?section_id=main-cart-items`)
      .then((r) => r.text())
      .then((html) => applySectionsFromResponse({ 'main-cart-items': html }))
      .catch(() => replaceMainCartSectionsFallback());
  }

  function replaceMainCartSectionsFallback() {
    const tasks = [];
    const cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl) {
      tasks.push(
        fetch(`${window.routes.cart_url}?section_id=main-cart-items`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('cart-items');
            if (next) {
              cartItemsEl.replaceWith(next);
            }
          })
          .catch(() => {})
      );
    }
    const cartFooterEl = document.getElementById('main-cart-footer');
    if (cartFooterEl) {
      tasks.push(
        fetch(`${window.routes.cart_url}?section_id=main-cart-footer`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const nextFooter = doc.querySelector('#main-cart-footer');
            if (nextFooter) {
              cartFooterEl.replaceWith(nextFooter);
            }
          })
          .catch(() => {})
      );
    }
    tasks.push(replaceCartIconBubble());
    return Promise.all(tasks);
  }

  function refreshAllCarts({ fullDrawer = false } = {}) {
    const tasks = [];
    tasks.push(fullDrawer ? replaceCartDrawerAll() : replaceCartDrawerFromSection());
    tasks.push(refreshCartPage());
    tasks.push(replaceCartIconBubble());
    return Promise.all(tasks);
  }

  // Helper: refresh drawer items/footer so #CustomGiftConfig reflects latest server-side qualification
  function refreshGiftConfig() {
    return replaceCartDrawerFromSection()
      .then(() => getGiftConfig())
      .catch(() => getGiftConfig());
  }

  // Subscribe to cart updates to enforce rules
  let enforcing = false;
  let rerunScheduled = false;
  try {
    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
      if (enforcing) {
        if (!rerunScheduled) {
          rerunScheduled = true;
          setTimeout(() => {
            rerunScheduled = false;
            try { enforceGiftRules(cartData); } catch (_) {}
          }, 120);
        }
        return;
      }
      enforceGiftRules(cartData);
      refreshOffers(cartData);
      setTimeout(() => { cartMutationInFlight = false; }, 30);
    });
  } catch (_) {
    // pubsub not available; ignore
  }

  // Keep main cart page in sync when drawer updates (no manual refresh)
  try {
    let cartPageSyncing = false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (cartPageSyncing) return;
      const cartPage = document.querySelector('cart-items');
      if (!cartPage) return;
      cartPageSyncing = true;
      Promise.all([refreshCartPage(), replaceCartIconBubble()]).finally(() => { cartPageSyncing = false; });
    });
  } catch (_) {
    // ignore
  }

  // If user clicks remove on the gift, suppress auto-add until threshold drops below and re-qualifies again
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-remove-button');
    if (!btn) return;
    cartMutationInFlight = true;
    const cfg = getGiftConfig();
    if (!cfg) return;
    const removedVarId = parseInt(btn.getAttribute('data-variant-id') || '0', 10) || 0;
    const removedProdId = parseInt(btn.getAttribute('data-product-id') || '0', 10) || 0;
    const matchesVariant = cfg.variantId && removedVarId === cfg.variantId;
    const matchesProduct = cfg.productId && removedProdId === cfg.productId;
    if (matchesVariant || matchesProduct) {
      setSuppressed(true);
    }
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-cart-offer-dismiss');
    if (!btn) return;
    const offer = btn.closest('.custom-cart-offer');
    if (!offer) return;
    const key = offer.dataset.offerKey || '';
    if (key) setDismissedOffer(key);
    hideOffer(offer);
    refreshOffers();
  });

  function enforceGiftRules(cartData) {
    if (enforcing) return;
    enforcing = true;
    setCheckoutLocked(true);
    const cfg = getGiftConfig();
    if (!cfg || !(cfg.variantId || cfg.productId)) {
      enforcing = false;
      setCheckoutLocked(false);
      return;
    }

    // Some cartUpdate events only include section HTML, not cart items. When that happens,
    // fetch the full cart so we can accurately clamp the gift quantity.
    const cartPromise = cartData && Array.isArray(cartData.items)
      ? Promise.resolve(cartData)
      : fetch(`${window.routes.cart_url}.js`).then((r) => r.json()).catch(() => null);

    cartPromise.then((resolvedCart) => {
      if (!resolvedCart || !Array.isArray(resolvedCart.items)) {
        enforcing = false;
        setCheckoutLocked(false);
        return;
      }

      const subtotalExGift = sumExcludingGift(resolvedCart, cfg.variantId, cfg.productId);
      const gift = findGiftItem(resolvedCart, cfg.variantId, cfg.productId);

      // Safety: never allow a gift to be the only item in the cart
      if (gift && subtotalExGift === 0) {
        changeByLine(gift.key || gift.index, 0)
          .finally(() => { enforcing = false; setCheckoutLocked(false); })
          .catch(() => {});
        setSuppressed(false);
        return;
      }

      // Threshold mode
      if (cfg.mode === 'threshold') {
        if (gift && cfg.threshold > 0 && subtotalExGift < cfg.threshold) {
          changeByLine(gift.key || gift.index, 0)
            .finally(() => { enforcing = false; setCheckoutLocked(false); })
            .catch(() => {});
          setSuppressed(false);
          return;
        }

        if (gift && gift.item.quantity && gift.item.quantity !== 1) {
          changeByLine(gift.key || gift.index, 1)
            .finally(() => { enforcing = false; setCheckoutLocked(false); })
            .catch(() => {});
          return;
        }

        if (!gift && cfg.autoAdd && cfg.available && cfg.threshold > 0 && subtotalExGift >= cfg.threshold && cfg.variantId && !isSuppressed()) {
          queueCartRequest(window.routes.cart_add_url, { id: cfg.variantId, quantity: 1 })
            .finally(() => { enforcing = false; setCheckoutLocked(false); })
            .catch(() => {});
          return;
        }

        enforcing = false;
        setCheckoutLocked(false);
        return;
      }

      // Inventory mode
      if (cfg.mode === 'inventory') {
        const ensureCfg = refreshGiftConfig().catch(() => cfg);
        ensureCfg.then((freshCfg) => {
          const c = freshCfg || cfg;

          if (gift && !c.qualified) {
            changeByLine(gift.key || gift.index, 0)
              .finally(() => { enforcing = false; setCheckoutLocked(false); })
              .catch(() => {});
            setSuppressed(false);
            return;
          }

          if (gift && gift.item.quantity && gift.item.quantity !== 1) {
            changeByLine(gift.key || gift.index, 1)
              .finally(() => { enforcing = false; setCheckoutLocked(false); })
              .catch(() => {});
            return;
          }

          if (!gift && c.autoAdd && c.available && c.variantId && !isSuppressed()) {
            if (!c.qualified) { enforcing = false; setCheckoutLocked(false); return; }
            queueCartRequest(window.routes.cart_add_url, { id: c.variantId, quantity: 1 })
              .finally(() => { enforcing = false; setCheckoutLocked(false); })
              .catch(() => {});
            return;
          }

          enforcing = false;
          setCheckoutLocked(false);
        }).catch(() => { enforcing = false; setCheckoutLocked(false); });
        return;
      }

      // Nothing to do (unknown mode)
      enforcing = false;
      setCheckoutLocked(false);
    }).catch(() => { enforcing = false; setCheckoutLocked(false); });
  }

  // Checkout guard: block checkout if gift is unqualified, re-run enforcement, then allow submit
  function giftUnqualified(cartData, cfg) {
    if (!cfg || !(cfg.variantId || cfg.productId) || !cartData || !Array.isArray(cartData.items)) return false;
    const gift = findGiftItem(cartData, cfg.variantId, cfg.productId);
    if (!gift) return false;
    const subtotalExGift = sumExcludingGift(cartData, cfg.variantId, cfg.productId);
    if (subtotalExGift === 0) return true;
    if (cfg.mode === 'threshold') {
      return cfg.threshold > 0 && subtotalExGift < cfg.threshold;
    }
    if (cfg.mode === 'inventory') {
      return !cfg.qualified;
    }
    return false;
  }

  function interceptCheckoutButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
      if (!btn) return;
      const form = btn.form || document.getElementById(btn.getAttribute('form') || '') || null;
      if (!form) return;

      e.preventDefault();
      if (cartMutationInFlight) {
        // A cart change is still in flight; block checkout until it settles
        setCheckoutLocked(true);
        setTimeout(() => { setCheckoutLocked(false); }, 250);
        return;
      }

      btn.disabled = true;
      setCheckoutLocked(true);
      fetch(`${window.routes.cart_url}.js`)
        .then((r) => r.json())
        .then((cartData) => {
          const cfg = getGiftConfig();
          const unqualified = giftUnqualified(cartData, cfg);
          if (unqualified) {
            enforceGiftRules(cartData);
            return { canSubmit: false };
          }
          return { canSubmit: true };
        })
        .catch(() => ({ canSubmit: false }))
        .then(({ canSubmit }) => {
          btn.disabled = false;
          setCheckoutLocked(false);
          if (canSubmit !== true) return;
          try {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(btn);
            } else {
              // Ensure checkout param is included
              const hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = btn.name || 'checkout';
              hidden.value = btn.value || 'Checkout';
              form.appendChild(hidden);
              form.submit();
              hidden.remove();
            }
          } catch (_) {}
        });
    }, true);
  }

  interceptCheckoutButtons();

  // Fallback: enforce once on load (covers initial state or when pubsub missed)
  window.addEventListener('DOMContentLoaded', () => {
    try {
      fetch(`${window.routes.cart_url}.js`)
        .then((r) => r.json())
        .then((cartData) => {
          enforceGiftRules(cartData);
          refreshOffers(cartData);
        })
        .catch(() => {});
    } catch (_) {}
  });
})();

// Global animation for custom sections
(function () {
  const body = document.body;
  if (!body) return;

  const animationSetting = body.dataset.customSectionAnimation;
  if (!animationSetting || animationSetting === 'none') return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (prefersReducedMotion.matches) {
    body.setAttribute('data-custom-section-animation', 'none');
    return;
  }

  const ANIMATION_SELECTOR = 'section[class^="custom-"], section[class*=" custom-"]';
  const trackedSections = new Set();

  function isCustomSection(section) {
    if (!section || !section.classList) return false;
    if (section.classList.contains('custom-footer')) return false;
    return Array.from(section.classList).some((cls) => cls.startsWith('custom-'));
  }

  function prepareSection(section) {
    if (!isCustomSection(section)) return null;

    const alreadyPrepared = section.classList.contains('custom-section-animate');
    trackedSections.add(section);

    if (!section.hasAttribute('data-animation-order')) {
      const order = trackedSections.size - 1;
      section.dataset.animationOrder = order;
      section.style.setProperty('--animation-order', order);
    } else if (section.dataset.animationOrder !== undefined) {
      section.style.setProperty('--animation-order', section.dataset.animationOrder);
    }

    if (!alreadyPrepared) {
      section.classList.add('custom-section-animate');
      if (window.Shopify && Shopify.designMode) {
        section.classList.add('is-visible');
      }
    } else if (window.Shopify && Shopify.designMode) {
      section.classList.add('is-visible');
    }

    return section;
  }

  function collectSections(root = document) {
    const nodes = root.querySelectorAll(ANIMATION_SELECTOR);
    const prepared = [];
    nodes.forEach((section) => {
      const result = prepareSection(section);
      if (result) prepared.push(result);
    });
    return prepared;
  }

  function reindexSections() {
    const ordered = Array.from(document.querySelectorAll(ANIMATION_SELECTOR)).filter((section) => isCustomSection(section));
    trackedSections.clear();
    ordered.forEach((section, index) => {
      trackedSections.add(section);
      if (!section.classList.contains('custom-section-animate')) {
        section.classList.add('custom-section-animate');
      }
      if (!section.hasAttribute('data-animation-order') || (window.Shopify && Shopify.designMode)) {
        section.dataset.animationOrder = index;
      }
      section.style.setProperty('--animation-order', index);
      if (window.Shopify && Shopify.designMode) {
        section.classList.add('is-visible');
      }
    });
    return ordered;
  }

  const sections = collectSections();
  if (!sections.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const target = entry.target;
      observer.unobserve(target);
      requestAnimationFrame(() => target.classList.add('is-visible'));
    });
  }, {
    rootMargin: '0px',
    threshold: 0.1,
  });

  if (!(window.Shopify && Shopify.designMode)) {
    sections.forEach((section) => observer.observe(section));
  }

  function handleSectionEvent(event) {
    let targetSections;
    if (event && event.type === 'shopify:section:reorder') {
      targetSections = reindexSections();
    } else {
      const container = event && event.target ? event.target : document;
      targetSections = collectSections(container);
    }

    if (window.Shopify && Shopify.designMode) return;

    targetSections.forEach((section) => {
      observer.observe(section);
    });
  }

  document.addEventListener('shopify:section:load', handleSectionEvent);
  document.addEventListener('shopify:section:reorder', handleSectionEvent);
  document.addEventListener('shopify:block:select', handleSectionEvent);

  // Watch for prefers-reduced-motion changes at runtime
  function onMotionPreferenceChange(event) {
    if (event.matches) {
      body.setAttribute('data-custom-section-animation', 'none');
      trackedSections.forEach((section) => section.classList.add('is-visible'));
    }
  }

  if (typeof prefersReducedMotion.addEventListener === 'function') {
    prefersReducedMotion.addEventListener('change', onMotionPreferenceChange);
  } else if (typeof prefersReducedMotion.addListener === 'function') {
    prefersReducedMotion.addListener(onMotionPreferenceChange);
  }
})();
